import React, { useState } from "react";
import "../styles/NavigatorСodehelppanel.css";
import { useGame } from "../GameContext";
type HelppanelProps = {
  type: number;
};
const Helppanel: React.FC<HelppanelProps> = ({ type }) => {
  console.log("HelpPanel render");
  const { isHelpPanelOpen, setHelpPanelOpen } = useGame();
  const [showhelpPivots, setShowhelpPivots] = useState<string>("pivotTask");

  if (!isHelpPanelOpen) {
    return null;
  }

  return (
    <div className="navigatorСode-helpPanel" id="navigatorСode-helpPanel">
      <img
        src="/img/close.svg"
        id="navigatorСode-closeButton"
        alt="Закрыть"
        className="navigatorСode-closeButton"
        onClick={() => setHelpPanelOpen(false)}
      />
      <div className="navigatorСode-helpPivots">
        <div
          className="navigatorСode-selectPivots"
          id={showhelpPivots === "pivotTask" ? "navigatorСode-activePivot" : ""}
          onClick={() => setShowhelpPivots("pivotTask")}
        >
          Задача
        </div>
      </div>
      {showhelpPivots === "pivotTask" && (
        <div id="navigatorСode-commandsCards">
          <div className="navigatorСode-helpCard">
            <div className="navigatorСode-cardCaption">Суть игры</div>
            
               {(() => {
                switch (type) {
                  case 1:
                    // Здесь можно добавить текст для типа 1
                    return <div>Content for type1</div>;
                  case 2:
                    // Здесь можно добавить текст для типа 2
                    return <div>Content for type2</div>;
                }
              })()}
            
          </div>
          <div className="navigatorСode-helpCard">
            <div className="navigatorСode-cardCaption">Правила игры</div>
            {(() => {
                switch (type) {
                  case 1:
                    // Здесь можно добавить текст для типа 1
                    return <div>Content for type1</div>;
                  case 2:
                    // Здесь можно добавить текст для типа 2
                    return <div>Content for type2</div>;
                }
              })()}
          </div>
        </div>
      )}
    </div>
  );
};
export default Helppanel;
